import Conditional from 'decorators/conditional';
import TwoLineRow from '../TwoLineRow';
import OneLineRow from '../OneLineRow';

export default Conditional({
  desktop: TwoLineRow,
  default: OneLineRow,
});
